import { render } from "./CommitList.vue?vue&type=template&id=4f074c5d"
import script from "./CommitList.vue?vue&type=script&lang=js"
export * from "./CommitList.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/automation-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__